import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import useRecaptcha from "../../../../hooks/useRecaptcha";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";
import { useForgotPasswordMutation } from "../../services/hooks/useForgotPasswordMutation";
import { EmailInput } from "./FormControls";
import { UpsellLoader } from "./FormControls/UpsellLoader";
import { Constants } from "../../../../constants/constants";

export const Step16ForgotPassword = () => {
  const { currentStep, goToStep, handleErrorResponse, onSubmitError, updateBaseProps } = useUpsellWidgetContainer();
  const { captchaToken, executeCaptcha, recaptchaRef, handleRecaptcha, resetCaptcha } = useRecaptcha();
  const { mutate: forgotPasswordMutation, isPending: isSubmitting } = useForgotPasswordMutation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  if (currentStep !== UpsellPanelSteps.Step16ForgotPassword) {
    return null;
  }

  const handleLoginSuccess = (response) => {
    if (response.status === Constants.RequestStatus.SUCCESS) {
      resetCaptcha();
      updateBaseProps({ successMessage: response.forgotPasswordSuccessMsg });
      goToStep(UpsellPanelSteps.Step3Login);
    } else if (response.errors) {
      handleErrorResponse(response.errors, setFormErrors);
    }
  }
  const onSubmit = async (formData) => {
    let token = captchaToken || await executeCaptcha();

    forgotPasswordMutation(
      { ...formData, captchaResponse: token },
      {
        onSuccess: handleLoginSuccess,
        onError: (error) => onSubmitError(error)
      });
  };


  return (
    <div className="step16">
      {isSubmitting && <UpsellLoader />}      
      <h3 className="text-center my-3">Forgotten password</h3>
      <p className="text-center">
        Please enter your email address below to request a new password
      </p>
      <form className="join-form-inline form-is-custom form-disable-pristine-error" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="row">
          <div className="col-12">
            <EmailInput register={register} errors={errors} />
          </div>
          <div className="col-12 mt-2">
            <ReCAPTCHA
              size="invisible"
              ref={recaptchaRef}
              sitekey={window.reCaptchaKey}
              onChange={handleRecaptcha}
            />
            <button className="btn btn-primary btn-fw btn-brand-style-with-pad-sm font-15-no-line-height" type="submit" >
              Send Request
            </button>
          </div>
          <div className="col-12 mb-3">
            Not a member?
            <a href="#" className="pl-2 link-primary" onClick={() => goToStep(UpsellPanelSteps.Step1SignUp)} >
              Sign up
            </a>
          </div>
          <div className="col-12 font-17-sm-down">
            Already a member?
            <a href="#" className="pl-2 link-primary" onClick={() => goToStep(UpsellPanelSteps.Step3Login)} >
              Log in
            </a>
          </div>
        </div>
      </form>
    </div>
  );
};

